module.exports = __webpack_public_path__ + "img/22.5677f4d2.jpg";